"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAppWebManifest = buildAppWebManifest;
/**
 * The App on its own address, installable: the address is its identity, its
 * start page the entry of the App.
 */
function buildAppWebManifest(manifest, host) {
    return {
        id: `https://${host}/`,
        name: manifest.name,
        short_name: manifest.name,
        start_url: '/',
        scope: '/',
        display: 'standalone',
    };
}
